import styled from 'styled-components';
import { StyledLink } from '../styles/ui';
import { fontSemibold16 } from '../styles/fonts';
import { Colors } from '../../../theme';
export const CustomLink = styled(StyledLink) `
  display: flex;
  justify-content: center;
  width: fit-content;
  margin: 0 auto 16px;
  border-radius: 4px;

  &.MuiLink-root {
    color: ${Colors.black80};
    background-color: ${(props) => (props.$isActive ? Colors.blue10 : Colors.white)};

    &:hover,
    &:focus,
    &:active {
      color: ${Colors.blue60};
      background-color: ${Colors.blue10};
    }
  }
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;

  .mainWrapper {
    display: flex;
    flex-direction: column;
  }

  .menuImage {
    max-width: 167px;
    border-radius: 2px;
  }

  .title {
    max-width: 167px;
    ${fontSemibold16}
  }
`;
//# sourceMappingURL=styles.js.map